import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getVideoById } from "@store/action/multimedia/VideoAction";
import CommentByTopic from "./CommentByTopic";
import DetailblogForm from "./CommentForm";
import VideoGallery from "./VideoGallery";
import FilterBlog from "./FilterBlog";
import "@styles/sass/5-pages/blog-details.scss";

const VideoById = () => {
  const dispatch = useDispatch();
  const store = useSelector((state) => state.VideoReducer);
  const { t } = useTranslation();
  const id = useParams().id;
  const datas = store.single;
  useEffect(() => {
    dispatch(getVideoById(id));
  }, [dispatch, id]);

  return (
    <div className="Ushno">
      <section className="single-banner">
        <div className="container__">
          <div className="row">
            <div className="col-lg-12">
              <div className="single-content">
                <h2>Video {t("Details")}</h2>
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">{t("Home")}</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={`/Gallery/Videos/topics`}>
                      Video-{t("Gallery")}
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Video-{t("Details")}
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="blog-det-part">
        <div className="container__video">
          <div className="row">
            <FilterBlog
              t={t}
              store={store}
              dispatch={dispatch}
              setCurrentPage={() => {}}
            />
            <div className="col-lg-9">
              <VideoGallery datas={datas} t={t} />
              <CommentByTopic t={t} dispatch={dispatch} />
              <DetailblogForm t={t} dispatch={dispatch} />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default VideoById;
